<template>
  <div class="modal-device-setting-component">
    <div class="modal-device-setting">
      <component
          ref="deviceInfo"
          v-if="isDevicetest"
          :is="infoComponent"
          :roomInfo="roomInfo"
          :isShowInfo.sync="isShowInfo"
          @reqJoin="reqJoin"
          @reqApproveJoin="reqApproveJoin"
      />
      <DeviceSettingPreview
          ref="devicePreview"
          :roomInfo="roomInfo"
          :isShowCoachmark="isShowCoachmark"
          :isDevicetest="isDevicetest"
          @onToggleInfo="toggleInfo"
          @reqJoin="reqJoin"
          @reqApproveJoin="reqApproveJoin"
          @onUpdatePreview="onUpdatePreview"
      />
    </div>

    <ModalDeviceSettingCoachmark
        v-if="isShowCoachmark"
        :isShowCoachmark.sync="isShowCoachmark"
    />
  </div>
</template>

<script>

import ModalDeviceSettingCoachmark from '@/components/Room/DeviceSetting/Coachmark'
import DeviceSettingInfo from '@/components/Room/DeviceSetting/Info/DeviceSettingInfo'
import DeviceSettingInfoWaiting from '@/components/Room/DeviceSetting/Info/DeviceSettingInfoWaiting'
import DeviceSettingPreview from '@/components/Room/DeviceSetting/Preview'
import {roomRecordApi} from "@/core/api/room.record.api";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: 'RoomDeviceSetting',
  components: {
    ModalDeviceSettingCoachmark,
    DeviceSettingInfo,
    DeviceSettingInfoWaiting,
    DeviceSettingPreview,
  },
  props: {
    roomInfo: Object,
    deviceSettings: Object,
    isDevicetest: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isInit: false,
      isShowCoachmark: true,
      isShowInfo: true,
      isWaitingRoom: false,
    }
  },
  mounted() {
    this.isEnabled({roomId: this.roomInfo.roomId})
        .then(res => {
          this.SET_ENABLED(res.enabled);
          this.SET_DEVICE_REQUIRED(res.isDeviceRequired);
        })
        .catch(e => {
          console.error(e);
          switch (e.message) {
            case 'NONE_ROOM':
              this.$alert({
                text: this.$t('deviceSetting.noRoom'),
                ok: async () => {
                  window.location.href = '/'
                },
                onlyOk: true
              })
              return;
            case 'NONE_ROOM_SETTING':
              this.$alert({
                text: this.$t('deviceSetting.noRoomSetting'),
                ok: async () => {
                  window.location.href = '/'
                },
                onlyOk: true
              })
              return;
          }
        });
  },
  computed: {
    infoComponent() {
      return this.enabled ? 'DeviceSettingInfoWaiting' : 'DeviceSettingInfo'
    },
    ...mapState('waitingRoom', ['enabled', 'deviceRequired']),
  },
  methods: {
    ...mapMutations('room',[
        'TOGGLE_MODAL_DEVICE_SETTING',
    ]),
    ...mapActions('waitingRoom',
        ['findAllByRoomIdApi', 'isEnabled', 'approveApi', 'disapproveApi', 'requestEnterApi',
         'disableWaitingRoomApi', 'leaveWaitingRoomApi', 'sendTestNoManagerInRoomApi', 'sendTestCloseRoomApi']),
    ...mapMutations('waitingRoom', [
      'CHANGE_ROLE_ID', 'ENTER_REQUESTED', 'ADD_WAITING_USER', 'APPROVAL', 'APPROVED',
      'DISAPPROVED', 'NO_PERMISSION', 'NO_MANAGER_IN_ROOM', 'ROOM_CLOSED',
      'SET_ENABLED', 'SET_DEVICE_REQUIRED'
    ]),
    closeModal(){
      if(!this._isDestroyed)
        this.TOGGLE_MODAL_DEVICE_SETTING(false)
    },
    toggleInfo() {
      this.isShowInfo = !this.isShowInfo
    },
    async reqJoin(){
      if(!this._isDestroyed){
        await this.$refs.devicePreview.deviceTestComplete();
        this.join();
      }
    },
    async reqApproveJoin() {
      let settings = this.$refs.devicePreview.getNecessarySettings

      if(this.deviceRequired && (!settings.video.deviceId ||!settings.audio.deviceId)) {
        this.$alert({
          text: this.$t('deviceSetting.essential'),
          onlyOk: true
        })

        return;
      }

      this.$refs.deviceInfo.reqApproveJoin(settings)
    },
    onUpdatePreview({deviceType, device}){
      let d = this[deviceType]
      if (!d) return

      if (d.deviceId === device.deviceId) {
        return
      }
      this[deviceType] = device
    },
    join() {
      try {
        let settings = this.$refs.devicePreview.getNecessarySettings

        roomRecordApi.setUserDevices(settings);
        this.$emit('deviceTestComplete', settings)
        this.$parent && this.$parent.$emit('deviceTestComplete', settings);
      } finally {
        this.closeModal()
      }
    },
  },
  watch: {
    enabled(val) {
    }
  },
}
</script>

<style lang="scss" scoped>
.modal-device-setting-component {
  width: 100%;
  height: 100%;
  display: grid;
  justify-content: center;
  align-items: center;
  overflow: auto;
}
.modal-device-setting {
  width: 700px;
  height: 740px;
  border-radius: 12px;
  background-color: $White;
  display: flex;
  position: relative;
  overflow: hidden;
}

[grm-device-mobile] {
  .modal-device-setting-component {
    display: flex;
  }
  .modal-device-setting {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
</style>